document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.selector-wrapper').forEach(selector => {
    selector.classList.add('is-visible');
  });
  if (document.querySelector('#descShowMore') != undefined) {
    //Quand on click sur "Voir plus" dans la description, on ouvre l'onglet "Description"
    document.querySelector('#descShowMore').addEventListener('click', function () {
      //L'onglet description est toujours le premier des onglets du tableau
      document.querySelectorAll('.tabs-nav__item')[0].click();
    });
  }
  if (document.querySelector('#toggleCustomSize') != undefined) {
    //Quand on click sur "Préciser votre taille", on affiche le formulaire de séléction de taille
    document.querySelector('#toggleCustomSize').addEventListener('click', function () {
      document.querySelector('#customSizeContainer').classList.add('is-visible');
    });
  }
  if (document.querySelector('#customSizeContainer .size-picker__close') != undefined) {
    document.querySelector('#customSizeContainer .size-picker__close').addEventListener('click', function () {
      document.querySelector('#customSizeContainer').classList.remove('is-visible');
      document.querySelector('#customSizeContainer select').value = document.querySelector('#customSizeContainer select option[data-default-option="true"]').value;
    });
  }

  //Engraving functionality
  let engraving_button = document.querySelector('.engraving-toggle__button');
  let engraving_confirm_button = document.querySelector('.engraving-form__confirm');
  if (engraving_button != undefined) {
    //On affiche le formulaire de gravure un court instant pour récupérer sa hauteur finale (invisible pour l'utilisateur)
    let engraving_form = document.querySelector('.engraving-form');
    engraving_form.style.display = 'flex';
    engraving_form.classList.add('initialized');

    //on met la hauteur à 0 pour le masquer, mais on conserve la valeur de la hauteur en mémoire pour l'animation
    let engraving_form_height = engraving_form.clientHeight;
    engraving_form.style.height = '0px';
    engraving_button.attributes['aria-expanded'].value = 'false';
    let input = engraving_form.querySelector('.engraving-form__text input');
    let select = engraving_form.querySelector('.engraving-form__typo select');
    engraving_button.addEventListener('click', function () {
      if (engraving_form.clientHeight == 0) {
        engraving_form.style.height = engraving_form_height + 'px';
        input.setAttribute('required', '');
        select.setAttribute('required', '');
      } else {
        engraving_form.style.height = '0px';
        if (input.value == '' || select.value == '') {
          input.value = '';
          select.querySelectorAll('option')[0].selected = true;
        }
        input.removeAttribute('required');
        select.removeAttribute('required');
        refreshEngravingButtonState();
      }
    });
    engraving_confirm_button.addEventListener('click', function () {
      let input = engraving_form.querySelector('.engraving-form__text input');
      let select = engraving_form.querySelector('.engraving-form__typo select');
      let has_engraving = engraving_button.classList.contains('has-engraving');
      let valid_form = true;

      // Si pas de valeur texte, je met le formulaire en erreur, sauf si l'utilisateur avait déjà remplis une gravure
      if (input.value == '' && !has_engraving) {
        input.classList.add('error');
        valid_form = false;
      } else {
        input.classList.remove('error');
      }

      //Si pas de typo sélectionnée, je met le formulaire en erreur
      if (select.value == '' && !has_engraving) {
        select.classList.add('error');
        valid_form = false;
      } else {
        select.classList.remove('error');
      }

      //Si le formulaire est valide, je cache le formulaire et je met à jour le bouton
      //Si l'utilisateur avait déjà remplis une gravure, je l'autorise a valider le formulaire sans avoir à remplir le champ texte pour effacer la gravure
      if (valid_form || has_engraving) {
        engraving_form.style.height = '0px';
        engraving_button.attributes['aria-expanded'].value = 'false';
        if (has_engraving && input.value == '') {
          input.value = '';
          select.querySelectorAll('option')[0].selected = true;
        }
        refreshEngravingButtonState();
      }
    });

    //Quand j'ajoute au panier, si je n'ai pas de gravure je retire la propertie "typographie". 
    document.querySelector('.shopify-product-form').addEventListener('submit', function clearTypoIfNeeded(e) {
      e.preventDefault();
      let has_engraving = document.querySelector('.engraving-form__text input').value !== '';
      if (!has_engraving) {
        document.querySelectorAll('.engraving-form__typo select option')[0].selected = true;
      }
      document.querySelector('.shopify-product-form').removeEventListener('submit', clearTypoIfNeeded);
      document.querySelector('.shopify-product-form').submit("submit");
    });
    function refreshEngravingButtonState() {
      //Si j'ai du texte dans le champ "Gravure", j'affiche le bouton "Modifier la gravure", sinon j'affiche le bouton "Ajouter une gravure"
      let has_engraving = document.querySelector('.engraving-form__text input').value !== '';
      if (has_engraving) {
        engraving_button.innerHTML = engraving_button.dataset.editLabel;
        engraving_button.classList.add('has-engraving');
      } else {
        engraving_button.innerHTML = engraving_button.dataset.defaultLabel;
        engraving_button.classList.remove('has-engraving');
      }
    }
  }

  //Show and hide colors based on the selected matiere
  //Ajoute un event listener sur toutes les div ayant la class "block-swatch" à l'intérieur de la div ayant la class "matiere-selector"
  // Au click, on récupère la value de l'input radio à l'intérieur de la div cliquée, et on affiche uniquement les couleurs correspondantes à cette value
  // pour ça on ajoute la class "visually-hidden" aux couleurs qui ne correspondent pas à la value de l'input radio et on la retire des couleurs qui correspondent
  //Les couleurs ont la class "color-swatch" et un attribut "data-matiere" qui correspond à la value de l'input radio
  // Une fois les images affichée, on click deux fois sur le color swatch correspondant à la couleur pour qu'il devienne sélectionné

  if (document.querySelector('.matiere-selector') != undefined) {
    document.querySelectorAll('.matiere-selector .block-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        let matiere = swatch.querySelector('input').value;
        let color_swatch = document.querySelectorAll('.color-swatch:not(.free-bracelet-color-swatch)');
        color_swatch.forEach(function (swatch) {
          if (swatch.dataset.matiere == matiere) {
            swatch.classList.remove('visually-hidden');
          } else {
            swatch.classList.add('visually-hidden');
          }
        });
        // Update clasp visibility based on selected matiere
        let clasp_swatches = document.querySelectorAll('.block-swatch-list .block-swatch[data-matiere]');
        clasp_swatches.forEach(function (claspSwatch) {
          if (claspSwatch.dataset.matiere == matiere) {
            claspSwatch.classList.remove('visually-hidden');
          } else {
            claspSwatch.classList.add('visually-hidden');
          }
        });
        const productVariantElement = document.querySelector('product-variants');
        const colorOptionIndex = document.querySelector(`.color-swatch:not(.visually-hidden):not(.free-bracelet-color-swatch) input`).name;
        let selected_color = document.querySelector(`.color-swatch:not(.visually-hidden):not(.free-bracelet-color-swatch) [value="${productVariantElement.selectedVariant[colorOptionIndex]}"]`);
        setTimeout(function () {
          // selected_color.click();
          //selected_color.checked = "checked"
        }, 50);
      });
    });
  }
  showHideTourBracelet();

  // Initialize value when content is loaded
  document.querySelector('.size-picker__input--number option').value = '';
  document.querySelector('.size-picker__input--number').selectedIndex = -1;
  document.querySelector('.size-picker__input--letter').selectedIndex = 0;
  document.querySelector('.size-picker__input--letter option').value = document.querySelector('.size-picker__input--letter option').dataset.value;
  document.addEventListener('variant:changed', function (event) {
    let variant = event.detail.variant; // Gives you access to the whole variant details;

    // Update free bracelet section based on selected variant
    updateFreeBraceletSection(variant);
    const matiereOptionIndex = document.querySelector(`.matiere-selector input`)?.name;
    const colorOptionIndex = document.querySelector(`.color-swatch:not(.visually-hidden) input`)?.name;
    const dateOptionIndex = document.querySelector(`.date-selector input`)?.name;
    const $messageNumber = document.querySelector('.size-picker__message--number');
    const $messageLetter = document.querySelector('.size-picker__message--letter');

    // Update clasp visibility based on selected matiere
    if (matiereOptionIndex != undefined && variant[matiereOptionIndex]) {
      let selectedMatiere = variant[matiereOptionIndex];
      let clasp_swatches = document.querySelectorAll('.block-swatch-list .block-swatch[data-matiere]');
      clasp_swatches.forEach(function (claspSwatch) {
        if (claspSwatch.dataset.matiere == selectedMatiere) {
          claspSwatch.classList.remove('visually-hidden');
        } else {
          claspSwatch.classList.add('visually-hidden');
        }
      });

      // Find the first visible clasp swatch and click on it only if no clasp with current material is already checked
      let visibleClasps = document.querySelectorAll('.block-swatch-list .block-swatch:not(.visually-hidden)[data-matiere]');
      let hasCheckedClasp = false;

      // Check if any visible clasp is already checked
      visibleClasps.forEach(function (claspSwatch) {
        let input = claspSwatch.querySelector('input[type="radio"]');
        if (input && input.checked) {
          hasCheckedClasp = true;
        }
      });

      // Only click first visible clasp if none are checked
      if (!hasCheckedClasp && visibleClasps.length > 0) {
        let firstVisibleClasp = visibleClasps[0].querySelector('input[type="radio"]');
        if (firstVisibleClasp) {
          firstVisibleClasp.click();
        }
      }
    }
    if (matiereOptionIndex != undefined) {
      acierList = ['Acier', 'Stainless steel', 'Stainless  steel', 'Steel', 'Acier / or', 'Stainless steel / gold', 'Stainless steel - gold', 'Acier / Plaqué or rose', 'Acier / Plaqué or rose', 'Steel / Rose gold plated', 'Steel / rose plated', 'Acier plaqué or', 'Stainless steel plated gold', 'Acier plaqué or jaune', 'Yellow gold plated steel', 'Acier plaqué or rose', 'Rose gold plated steel', 'Caoutchouc', 'Rubber', 'Caoutchouc DLC', 'Rubber DLC', "Steel / gold"];
      acierList = acierList.map(item => item.toLowerCase()); // Convert all elements to lowercase

      if (acierList.includes(variant[matiereOptionIndex].toLowerCase())) {
        //Si c'est de l'acier : 
        //1. j'affiche les bon éléments : 
        document.querySelector('.size-picker .with_default').classList.add('visually-hidden');
        document.querySelector('.size-picker .with_default').classList.remove('is-visible');
        document.querySelector('.size-picker .without_default').classList.add('is-visible');
        document.querySelector('.size-picker .without_default').classList.remove('visually-hidden');
        document.querySelector('.size-picker__container').classList.add('is-visible');
        document.querySelector('.size-picker__required').classList.add('is-visible');
        document.querySelector('.size-picker__required').classList.remove('visually-hidden');
        document.querySelector('.size-picker__close').classList.remove('is-visible');
        document.querySelector('.size-picker__close').classList.add('visually-hidden');
        document.querySelector('.size-picker__chart').classList.add('visually-hidden');
        document.querySelector('.size-picker__chart').classList.remove('is-visible');
        $messageNumber?.classList.add('is-visible');
        $messageNumber?.classList.remove('visually-hidden');
        $messageLetter?.classList.add('visually-hidden');
        $messageLetter?.classList.remove('is-visible');
        document.querySelector('.size-picker__input--number').setAttribute('required', 'required');
        document.querySelector('.size-picker__input--letter').removeAttribute('required');
        document.querySelector('.size-picker__input--letter').setAttribute('disabled', 'disabled');
        document.querySelector('.size-picker__input--number').removeAttribute('disabled');
        document.querySelector('.select-wrapper--letter').classList.add('visually-hidden');
        document.querySelector('.select-wrapper--number').classList.remove('visually-hidden');
        document.querySelector('.select-wrapper--number').classList.add('is-visible');
        document.querySelector('.select-wrapper--letter').classList.remove('is-visible');

        //2. j'ajoute les class utilitaires : 
        document.querySelector('.size-picker').classList.add('required');
        document.querySelector('.select__selected-value--number').textContent = document.querySelector('.select__selected-value--number').getAttribute('data-default-text');
        document.querySelector('.select-wrapper.is-visible .size-picker__input option').value = '';
        document.querySelector('.select-wrapper.is-visible .size-picker__input').selectedIndex = -1;
        document.querySelector(".select-wrapper.is-visible .combo-box__option-item[aria-selected='true']")?.setAttribute('aria-selected', false);
        updateCustomSizeSelector(event, variant);
      } else {
        //Si ce n'est pas de l'acier :
        document.querySelector('.size-picker .with_default').classList.add('is-visible');
        document.querySelector('.size-picker .with_default').classList.remove('visually-hidden');
        document.querySelector('.size-picker .without_default').classList.add('visually-hidden');
        document.querySelector('.size-picker .without_default').classList.remove('is-visible');
        document.querySelector('.size-picker__container').classList.remove('is-visible');
        document.querySelector('.size-picker__required').classList.remove('is-visible');
        document.querySelector('.size-picker__required').classList.add('visually-hidden');
        document.querySelector('.size-picker__close').classList.add('is-visible');
        document.querySelector('.size-picker__close').classList.remove('visually-hidden');
        document.querySelector('.size-picker__chart').classList.add('is-visible');
        document.querySelector('.size-picker__chart').classList.remove('visually-hidden');
        $messageLetter?.classList.add('is-visible');
        $messageLetter?.classList.remove('visually-hidden');
        $messageNumber?.classList.add('visually-hidden');
        $messageNumber?.classList.remove('is-visible');
        document.querySelector('.size-picker__input--letter').setAttribute('required', 'required');
        document.querySelector('.size-picker__input--number').removeAttribute('required');
        document.querySelector('.size-picker__input--letter').removeAttribute('disabled');
        document.querySelector('.size-picker__input--number').setAttribute('disabled', 'disabled');
        document.querySelector('.select-wrapper--letter').classList.remove('visually-hidden');
        document.querySelector('.select-wrapper--number').classList.add('visually-hidden');
        document.querySelector('.select-wrapper--letter').classList.add('is-visible');
        document.querySelector('.select-wrapper--number').classList.remove('is-visible');

        //2. j'ajoute les class utilitaires :
        document.querySelector('.size-picker').classList.remove('required');
        document.querySelector('.select__selected-value--letter').textContent = document.querySelector('.select__selected-value--letter').getAttribute('data-default-text');
        document.querySelector('.select-wrapper.visually-hidden .size-picker__input option').value = '';
        document.querySelector('.select-wrapper.visually-hidden .size-picker__input').selectedIndex = -1;
        document.querySelector('.select-wrapper.is-visible .size-picker__input option').value = document.querySelector('.select-wrapper.is-visible .size-picker__input option').dataset.value;
        document.querySelector('.select-wrapper.is-visible .size-picker__input').selectedIndex = 0;
        document.querySelector(".select-wrapper.is-visible .combo-box__option-item[aria-selected='true']")?.setAttribute('aria-selected', false);
      }
    }
    if (colorOptionIndex != undefined) {
      let selected_color = document.querySelector(`.color-swatch:not(.visually-hidden) [value="${variant[colorOptionIndex]}"]`);
      selected_color.click();
      selected_color.checked = "checked";
    }

    // If a new date is selected, update the size selector
    if (dateOptionIndex != undefined) {
      let dateInputs = document.querySelectorAll(`.date-selector .block-swatch__item`);
      dateInputs.forEach(function (dateInput) {
        dateInput.addEventListener('click', function (e) {
          updateCustomSizeSelector(e, variant);
        });
      });
    }
    if (window.variant_metafields[variant.id] != undefined) {
      let metas = window.variant_metafields[variant.id];
      Object.keys(metas).forEach(element => {
        document.querySelector(`.product-tabs__table-row[data-key="${element}"] .product-tabs__table-row-value`).innerHTML = metas[element];
      });
    }
    showHideTourBracelet();
  });
  document.querySelector('#AddToCart').addEventListener('click', e => {
    var selectedSize = document.querySelector('.select-wrapper.is-visible .size-picker__input').value;

    // Check if value ''
    if (selectedSize === '') {
      //add border red on input size
      document.querySelector('.select-wrapper.is-visible button.select').style.borderColor = 'red';
    }
  });
  if (document.querySelector('#ShowColorFreeBracelet') != undefined) {
    document.querySelector('#ShowColorFreeBracelet').addEventListener('click', function () {
      document.querySelector('.free-bracelet-color-swatch-list').classList.add('expanded');
    });
  }
  if (document.querySelector('.tour-bracelet-swatch') != undefined) {
    document.querySelectorAll('.tour-bracelet-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        if (e.target.value != undefined) {
          filterBraceletBySimpleOrDouble(e.target.closest('product-variants'), e.target.value);
          setTimeout(function () {
            e.target.closest('product-variants').querySelector('.color-swatch:not(.visually-hidden):not(.hide-tour-bracelet) .color-swatch__item').click();
            e.target.closest('product-variants').querySelector('.color-swatch:not(.visually-hidden):not(.hide-tour-bracelet) input').checked = true;
          }, 50);
        }
      });
    });
  }
  if (document.querySelector('.tour-free-bracelet-selector') != undefined) {
    document.querySelectorAll('.tour-free-bracelet-selector .tour-bracelet-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        document.querySelector('#ShowColorFreeBracelet').click();
      });
    });
  }
  function filterBraceletBySimpleOrDouble(productVariant, simpleOrDouble) {
    productVariant.querySelectorAll('.color-swatch:not(.visually-hidden) input').forEach(function (swatch) {
      let doubleTourValues = window.freeBraceletTranslations.double_tour.split(',').map(value => value.trim().toLowerCase());
      if (simpleOrDouble == window.freeBraceletTranslations.simple) {
        if (doubleTourValues.some(value => swatch.value.toLowerCase().includes(value))) {
          swatch.closest('.color-swatch').classList.add('hide-tour-bracelet');
        } else {
          swatch.closest('.color-swatch').classList.remove('hide-tour-bracelet');
        }
      } else if (simpleOrDouble == window.freeBraceletTranslations.double) {
        if (doubleTourValues.some(value => swatch.value.toLowerCase().includes(value))) {
          swatch.closest('.color-swatch').classList.remove('hide-tour-bracelet');
        } else {
          swatch.closest('.color-swatch').classList.add('hide-tour-bracelet');
        }
      }
    });
  }
  function updateFreeBraceletSection(variant) {
    // Get the free bracelet container
    const freeBraceletContainer = document.querySelector('.free-bracelet-container');
    if (!freeBraceletContainer) return;

    // Get the section ID from the container
    const sectionId = freeBraceletContainer.dataset.sectionId;
    if (!sectionId) return;

    // Use Shopify's Section Rendering API to re-render the free bracelet section with the current variant
    fetch(`${window.location.pathname}?section_id=${sectionId}&variant=${variant.id}`).then(response => response.text()).then(html => {
      // Create a temporary element to parse the HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      // Extract the free bracelet section from the response
      const newFreeBraceletSection = tempDiv.querySelector('.free-bracelet-container');

      // If we got a valid response with content, update the section
      if (newFreeBraceletSection) {
        freeBraceletContainer.innerHTML = newFreeBraceletSection.innerHTML;

        // Check if the product-variants element exists and has an empty handle attribute
        const updatedProductVariantElement = freeBraceletContainer.querySelector('product-variants');
        if (updatedProductVariantElement && updatedProductVariantElement.getAttribute('handle') == '') {
          // If handle is empty, add visually-hidden class to the free bracelet container
          freeBraceletContainer.classList.add('visually-hidden');

          // Empty the name of the input with the property
          const colorSwatchInputs = freeBraceletContainer.querySelectorAll('.color-swatch__radio');
          colorSwatchInputs.forEach(input => {
            input.name = '';
          });
        } else {
          freeBraceletContainer.classList.remove('visually-hidden');
        }

        // Rebind the click event listener to the #ShowColorFreeBracelet element
        const showColorFreeBracelet = document.querySelector('#ShowColorFreeBracelet');
        if (showColorFreeBracelet) {
          // Remove any existing event listeners (to avoid duplicates)
          const newShowColorFreeBracelet = showColorFreeBracelet.cloneNode(true);
          showColorFreeBracelet.parentNode.replaceChild(newShowColorFreeBracelet, showColorFreeBracelet);

          // Add the event listener again
          newShowColorFreeBracelet.addEventListener('click', () => {
            document.querySelector('.free-bracelet-color-swatch-list').classList.add('expanded');
          });
        }
      } else {
        // If no free bracelet for this variant, hide the section
        freeBraceletContainer.classList.add('visually-hidden');
      }
    }).catch(error => {
      console.error('Error', error);
    });
  }
  function showHideTourBracelet() {
    if (document.querySelectorAll('.tour-bracelet-swatch').length > 0) {
      document.querySelectorAll('.tour-bracelet-swatch').forEach(function (swatch) {
        let doubleTourValues = window.freeBraceletTranslations.double_tour.split(',').map(value => value.trim().toLowerCase());
        let doubleBracelet = Array.from(swatch.closest('product-variants').querySelectorAll('.color-swatch:not(.visually-hidden) input')).filter(function (input) {
          return doubleTourValues.some(value => input.value.toLowerCase().includes(value));
        });

        // console.log(doubleBracelet)
        // console.log(  document.querySelector('.tour-bracelet-selector'))
        if (doubleBracelet.length > 0) {
          swatch.closest('product-variants').querySelector('.tour-bracelet-selector, .tour-free-bracelet-selector').classList.remove('visually-hidden');
          filterBraceletBySimpleOrDouble(swatch.closest('product-variants'), swatch.closest('product-variants').querySelector('.tour-bracelet-swatch .block-swatch__radio:checked').value);
        } else {
          swatch.closest('product-variants').querySelector('.tour-bracelet-selector, .tour-free-bracelet-selector').classList.add('visually-hidden');
        }
      });
    }
  }
  function updateCustomSizeSelector(e, variant) {
    // UPDATE THE SIZE SELECTOR
    let variantIdString = variant.id.toString(); // To compare with the keys in customSizeSelector

    // Check if variant id matches with one of the keys in customSizeSelector (customSizeSelector contains variant which has custom size)
    if (Object.keys(window.customSizeSelector).includes(variantIdString)) {
      // Update values in the size selector

      // 1. Define new min and max values
      let min_bracelet_size = window.customSizeSelector[variantIdString].min;
      let max_bracelet_size = window.customSizeSelector[variantIdString].max;

      /* 
        DEFINE FALLBACK VALUES
        If min and max are empty (if variant has no custom size), keep the default values from the product metafields
      */
      let firstDropdownOption = e.target.closest('.product-form').querySelectorAll('.select-wrapper--number .combo-box__option-item')[0];
      let lastDropdownOption = e.target.closest('.product-form').querySelectorAll('.select-wrapper--number .combo-box__option-item')[e.target.closest('.product-form').querySelectorAll('.select-wrapper--number .combo-box__option-item').length - 1];
      if (min_bracelet_size == '') {
        min_bracelet_size = firstDropdownOption.dataset.valueNumber;
      }
      if (max_bracelet_size == '') {
        max_bracelet_size = lastDropdownOption.dataset.valueNumber;
      }

      // 2. Remove all options and create new ones
      const productForm = e.target.closest('.product-form');
      const optionList = productForm.querySelector('.combo-box__option-list--number');
      const selectElement = productForm.querySelector('.size-picker__input--number');

      // Remove existing button options
      optionList.querySelectorAll('.combo-box__option-item').forEach(function (item) {
        item.remove();
      });

      // Remove existing select options (except the default one)
      Array.from(selectElement.options).forEach(function (option) {
        if (!option.hasAttribute('data-default-option')) {
          option.remove();
        }
      });
      for (let i = parseFloat(min_bracelet_size); i <= parseFloat(max_bracelet_size); i++) {
        // Format integer value
        const intValue = i.toString();
        const intValueFormatted = intValue + ' cm';

        // Add integer value button
        let newOption = document.createElement('button');
        newOption.setAttribute('type', 'button');
        newOption.setAttribute('role', 'option');
        newOption.classList.add('combo-box__option-item');
        newOption.setAttribute('value', intValueFormatted);
        newOption.setAttribute('data-value-number', intValue);
        newOption.textContent = intValueFormatted;
        optionList.appendChild(newOption);

        // Add integer value to select
        let selectOption = document.createElement('option');
        selectOption.value = intValueFormatted;
        selectOption.textContent = intValueFormatted;
        selectElement.appendChild(selectOption);

        // Add half value if not at max
        if (i + 0.5 <= parseFloat(max_bracelet_size)) {
          // Format decimal value with comma (matching template format)
          const halfValue = (i + 0.5).toString().replace('.', ',');
          const halfValueFormatted = halfValue + ' cm';

          // Add half value button
          let halfOption = document.createElement('button');
          halfOption.setAttribute('type', 'button');
          halfOption.setAttribute('role', 'option');
          halfOption.classList.add('combo-box__option-item');
          halfOption.setAttribute('value', halfValueFormatted);
          halfOption.setAttribute('data-value-number', (i + 0.5).toString().replace('.', ','));
          halfOption.textContent = halfValueFormatted;
          optionList.appendChild(halfOption);

          // Add half value to select
          let selectHalfOption = document.createElement('option');
          selectHalfOption.value = halfValueFormatted;
          selectHalfOption.textContent = halfValueFormatted;
          selectElement.appendChild(selectHalfOption);
        }
      }
    }
  }
});

// Initialize flickity slider for picto section on product page
document.addEventListener('DOMContentLoaded', function () {
  var flkty = new Flickity('.picto__slider', {
    "contain": true,
    "cellAlign": "left",
    "pageDots": true,
    "prevNextButtons": false
  });
});